import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Octicon, { getIconByName } from '@github/octicons-react'; //https://octicons.github.com/

class UserMessaging extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            verify: false,
            validationMessage: props.validationMessage
        };
    }

    componentWillMount() {
        if (this.props.edit === false) {
            this.setState({
                showEdit: false,
                verify: false,
                validationMessage: ''
            });            
        }
    }

    componentDidUpdate() {
    }

    getMobileWithoutCountry() {
        const prefix = this.getCountryPrefixFromMobile();

        if (this.props.mobile) {
            return this.props.mobile.replace(prefix, '');
        }

        return '';
    }

    getCountryPrefixFromMobile() {

        let prefix = '';
        const countries = this.props.countries.sort((a, b) => {
            if (b && a) {
                return b.length - a.length;
            }
            return 0;
        });

        countries.forEach((item) => {
            //this.props.mobile.startsWith(item.prefix) doesn't work in IE because its a great browser
            if (this.props.mobile && this.props.mobile.lastIndexOf(item.prefix, 0) === 0) {
                prefix = item.prefix;
            }
        });

        return prefix;
    }

    enableEdit = (event) => {
        event.preventDefault();
        this.setState({
            showEdit: true,
            verify: true
        });
    }

    cancel = (event) => {
        event.preventDefault();
        if (this.state.showEdit === true) {
            this.setState({
                showEdit: false,
                verify: false,
                validationMessage: ''
            });
        }
        this.props.onCancel();
    }

    resend = () => {
        this.props.onResendVerificationCode();
    }

    verify = (event) => {
        event.preventDefault();
        
        if (this.props.codeSent === false && (this.refs.mobile.value !== this.refs.mobileConfirm.value
            || this.refs.countryPrefixMobile.value !== this.refs.countryPrefixMobileConfirm.value)) {
            this.setState({
                validationMessage: 'Mobile numbers provided don\'t match'
            });
        }
        else if (this.refs.mobileConfirm && /^[0-9]{10,12}$/.test(this.refs.mobileConfirm.value.replace(/ /g, '')) === false) {
            this.setState({
                validationMessage: 'Please provide a valid phone number'
            });
        }
        else if (this.props.codeSent === true && this.refs.verificationCode.value.length > 1) {

            this.setState({
                validationMessage: '',
                showEdit: false
            });

            this.props.onMobileVerify(this.refs.verificationCode.value);
        }
        else if (this.refs.mobile && this.refs.mobile.value === this.refs.mobileConfirm.value
            && this.refs.countryPrefixMobile.value === this.refs.countryPrefixMobileConfirm.value) {
            this.setState({
                validationMessage: ''
            });

            this.props.onMobileUpdate(this.refs.countryPrefixMobile.value + this.refs.mobile.value.replace(/ /g, ''));
        } 
    }

    getTitle() {
        let title = 'Mobile';

        if (this.state.showEdit && !this.props.codeSent) {
            title = 'Mobile Number - Enter your mobile number';
        }
        else if (this.props.codeSent) {
            title = 'Mobile Number - Enter your verification code';

            const message = this.state.validationMessage.length > 1 ? this.state.validationMessage : this.props.validationMessage;

            if (message && message.length > 1) {
                title = 'Mobile Number – Enter correct code';
            }
        }

        return title;
    }

    renderMobileVerified() {
        if (this.props.verified) {
            return (
                <div>
                    <div style={{ clear: 'both' }} />
                    <div className='mt-1'>
                        <p>The above phone number has been verified. Click the edit button to change your mobile number.</p>
                    </div>
                </div>
            );
        }
        else if (this.props.mobile && this.props.mobile.length > 5) {
            return (
                <div>
                    <span className='ml-1'>
                        <Octicon icon={getIconByName('alert')} className='text-warning' />
                    </span>
                    <div style={{ clear: 'both' }} />
                    <div className='mt-1'>
                        <p>The phone number provided is not verified</p>
                    </div>
                </div>
            );
        }
    }

    renderCodeValidation() {
        if (this.props.codeSent) {
            return (
                <div className='form-group' style={{ clear: 'both' }}>
                    <br/>
                    <p>Your verification code has been sent.  Please check your mobile and enter the code in the box below within 3 minutes.</p>
                    <span style={{ width: '80%', float: 'left' } }>
                        <input id='verificationCode' ref='verificationCode' type='text' className='form-control' placeholder='Enter verification code' autoComplete='off' />
                    </span>
                    <div style={{ clear: 'both' }} />
                    {this.renderWarning()}
                </div>

            );
        }
    }
    renderConfirm() {
        if (this.state.showEdit && !this.props.codeSent) {
            return (
                <div>
                    <div className='mt-1'>
                        <p>Please enter your mobile number in both boxes below. Please do not include the leading zero from your mobile number, for example: 0777 123456 must be supplied as 777 123456)</p>
                    </div>
                    <div className='form-group'>
                        {this.renderPrefixDropDown('countryPrefixMobile')}
                        <span style={{ width: '80%', float: 'left' }}>
                            <input id='mobile' ref='mobile' type='text' className='form-control' placeholder='Mobile Number' autoComplete='off' defaultValue={this.getMobileWithoutCountry(this.props.mobile)} />
                        </span>
                        <div style={{ clear: 'both'}} />
                    </div>
                    <div className='form-group'>
                        {this.renderPrefixDropDown('countryPrefixMobileConfirm')}
                        <span style={{ width: '80%', float: 'left' }}>
                            <input id='mobileConfirm' ref='mobileConfirm' type='text' className='form-control' placeholder='Confirm Mobile Number' autoComplete='off' />
                        </span>
                        <div style={{ clear: 'both' }} />
                        {this.renderWarning()}
                    </div>
                </div>
            );

        }
        else if (!this.state.showEdit && !this.props.codeSent) {
            return (
                <div className='form-group'>
                    <span style={{ width: '95%', float: 'left' }}>
                        <input id='mobile' ref='mobile' type='text' className='form-control mb-2' placeholder='Mobile Number' autoComplete='off' value={this.props.mobile} disabled />
                    </span>
                    <span style={{ marginLeft: '5px'}}>
                        {this.renderMobileVerified()}
                    </span>
                </div>
                );
        }
    }

    renderPrefixDropDown(refName, selectedOption) {
        if (this.state.showEdit) {
            return (
                <span style={{ width: '95px', float: 'left' }}>
                    <select id={refName} ref={refName} className='form-control mb-2'>
                        {this.renderCountryOptions(selectedOption)}
                    </select>
                </span>
            );
        }
    }

    renderCountryOptions(selectedOption) {

            return (
                this.props.countries.map((item, index) =>
                    <option key={index} value={item.prefix} selected={item.prefix === selectedOption}>{item.prefix}</option>
                )
            );  
    }

    renderResendButton() {
        if (this.props.codeSent) {
            return <button className='button button-primary mr-1' onClick={this.resend}>Resend</button>;
        }

        return '';
    }

    renderVerifyButton() {
        if ((this.state.verify && this.state.showEdit) || this.props.codeSent) {
            return (
                <div className='form-group text-right'>
                    <span>
                        {this.renderResendButton()}      
                    </span>
                    <span>
                        <button className='button button-primary mr-1' onClick={this.verify}>Verify</button>
                    </span>
                    <span>
                        <button className='button button-primary' onClick={this.cancel}>Cancel</button>
                    </span>
                </div>
            );
        }

        return '';
    }

    renderWarningIcon() {
        if (this.props.showWarning) {
            return <Octicon icon={getIconByName('alert')} className='text-warning mr-2' />;
        }
        return '';
    }
    renderWarning() {

        const message = this.state.validationMessage.length > 1 ? this.state.validationMessage : this.props.validationMessage;

        if (message && message.length > 1) {
            return (
                <h3 className='form-group text-left'>
                    {this.renderWarningIcon()}
                    {message}
                </h3>
            );
        }

        return '';
    }

    renderEditButton() {
        if (!this.state.showEdit && this.props.canEdit === true && !this.props.codeSent) {
            return (
                <div className='form-group text-right mt-2'>
                    <div style={{ clear: 'both' }} />
                    <button className='button button-primary' onClick={this.enableEdit}>{this.props.mobile && this.props.mobile.length > 1 ? 'Edit' : 'Add'}</button>
                </div>
            );
        }
    }

    render() {
        return (
            <div>
                <h2 className='mt-3'>{this.getTitle()}</h2>
                
                {this.renderConfirm()}
                {this.renderCodeValidation()}
                {this.renderEditButton()}
                {this.renderVerifyButton()}
            </div>
        );
    }
}

export default UserMessaging;


// WEBPACK FOOTER //
// ./src/components/User/UserMessaging.js